import * as _ from "lodash";
import { Messages } from "primereact/messages";

export class Utility {
  public static validateStringLength(value: any, length: number): boolean {
    return value.length === length;
  }

  public static validatePersonalId(value: any): boolean {
    if (!Utility.validateStringLength(value, 13)) return false; //neodgovarajuca duzina jmbg

    let daysInMonth: number[] = [
      31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
    ];
    const now = new Date();
    const day = parseInt(value.substr(0, 2));
    const month = parseInt(value.substr(2, 2));
    let year = parseInt(value.substr(4, 3));
    if (year < 100) {
      year += 2000; //born after 2000.
    } else {
      year += 1000; //born before 2000.
    }
    const personalIdDate = new Date(year, month - 1, day).getTime();

    if (personalIdDate > now.getTime()) return false; //uneti datum Jmbg veci od danasnjeg datuma

    if (year > now.getFullYear() || year < 1900) return false; // neodgovarajuca godina (5,6,7 cifra jmbg)

    if (month > 12 || month < 1) return false; // neodgovarajuci mesec (3,4 cifra jmbg)

    if (year % 4 === 0 && (year % 100 !== 0 || year % 400 !== 0))
      daysInMonth[1] = 29; //prestupna godina

    if (day < 1 || day > daysInMonth[month - 1]) return false; //neodgovarajuci dan (1,2 cifra jmbg)

    //formula za racunanje kontrolnog zbira
    let sum = 0;
    for (let i = 0; i < 6; i++) {
      sum += (7 - i) * (parseInt(value[i]) + parseInt(value[6 + i]));
    }
    let rest = sum % 11;

    if (rest === 1) return false; //nedozvoljen kontrolni broj

    let controlNumber = 11 - rest;
    if (controlNumber === 11) controlNumber = 0;

    if (controlNumber !== parseInt(value[12])) return false; //provera ispravnosti kontrolnog broja

    return true; //bez grešaka, jmbg validan
  }

  public static cloneDeep(object: any) {
    return _.cloneDeep(object);
  }

  public static formatDate(date: Date) {
    return `${date.getDate() < 10 ? "0" : ""}${date.getDate()}.${
      date.getMonth() < 9 ? "0" : ""
    }${1 + date.getMonth()}.${date.getFullYear()}.`;
  }

  public static formatTime = (date: Date) => {
    return `${date.getHours() < 10 ? "0" : ""}${date.getHours()}:${
      date.getMinutes() <= 9 ? "0" : ""
    }${date.getMinutes()}`;
  };

  public static normalizeDate = (date: Date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  public static addThousandSeparator(num: number, separator: string = ".") {
    const t = "" + num;
    const numberOfInserts = Math.floor((t.length - 1) / 3);
    if (numberOfInserts === 0) {
      return t;
    }
    let res = "";
    let cnt = 0;
    for (let i = t.length - 1; i >= 0; i--) {
      res = t[i] + res;
      cnt++;
      if (cnt % 3 === 0) {
        res = separator + res;
      }
    }
    if (res[0] === ".") res = res.slice(1);
    if (num < 0 && res[1] === ".") res = "-" + res.slice(2);
    return res;
  }

  public static getPropByString(obj: any, propString: string) {
    if (!propString) return obj;

    var prop,
      props = propString.split(".");

    for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
      prop = props[i];
      if (prop == undefined || obj[prop] == undefined) continue;
      var candidate = obj[prop];
      if (candidate !== undefined) {
        obj = candidate;
      } else {
        break;
      }
    }
    return obj[props[i]];
  }

  public static normalizeAmount = (value: any) => {
    if (value === null || value === undefined) return undefined;

    const num = Number(value);
    if (Number.isNaN(num)) return undefined;

    // ako je ceo broj -> 5
    if (Number.isInteger(num)) return num;

    // ako nije, zaokruži na 3 decimale
    return Number(num.toFixed(3));
  };

  //@ts-ignore
  public static Messages: Messages = null;

  public static showErrorMessage(summary: string, detail: string): void {
    //@ts-ignore
    Messages.show({ severity: "error", closable: false, summary, detail });
  }

  public static formatAmount = (value?: number | null) => {
    if (value == null) return "/";
    const num = Number(value);
    if (Number.isNaN(num)) return "";
    return Number.isInteger(num) ? num.toString() : num.toFixed(3);
  };

  public static toMiddayDate = (
    value?: Date | string | null
  ): Date | undefined => {
    if (!value) return undefined;
    const d = new Date(value);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0, 0);
  };

  public static clampDateToRange = (date: Date, min: Date, max: Date) => {
    if (date < min) return min;
    if (date > max) return max;
    return date;
  };

  public static parseDocDate(value: unknown): Date | null {
    if (!value) return null;

    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }

    if (typeof value === "string") {
      const s = value.trim();

      const m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})\.?$/);
      if (m) {
        const day = Number(m[1]);
        const month = Number(m[2]);
        const year = Number(m[3]);
        const d = new Date(year, month - 1, day);
        return isNaN(d.getTime()) ? null : d;
      }

      const d = new Date(s);
      return isNaN(d.getTime()) ? null : d;
    }

    return null;
  }
}
